import { useEffect, useState } from "react";
import api from "@/lib/api";
import { eaParams, useEa } from "./EaContext";

// Carica un endpoint /ea/* con i filtri globali correnti più parametri della pagina.
export function useEaData(path, extra = {}) {
  const { filters, ready } = useEa();
  const [state, setState] = useState({ data: null, loading: true, error: null });
  const key = JSON.stringify(extra);
  useEffect(() => {
    if (!ready) return;
    let alive = true;
    setState((s) => ({ ...s, loading: true, error: null }));
    api.get(path, { params: eaParams(filters, extra) })
      .then(({ data }) => alive && setState({ data, loading: false, error: null }))
      .catch((e) => {
        const d = e?.response?.data?.detail;
        alive && setState({ data: null, loading: false, error: typeof d === "string" ? d : d?.message || "Errore nel caricamento dei dati" });
      });
    return () => { alive = false; };
  }, [path, filters.company, filters.year, ready, key]); // eslint-disable-line react-hooks/exhaustive-deps
  return state;
}
